import { Injectable } from "@angular/core";
import { ToastController, AlertController } from "ionic-angular";

if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    padString = String(typeof padString !== "undefined" ? padString : " ");
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

@Injectable()
export class Util {
  constructor(
    private toastCtrl: ToastController,
    private alertCtrl: AlertController
  ) {
    window["flagEnabled"] = (key) => localStorage["flag-" + key] === "true";
  }

  public html2Txt(html) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  public showToast(text: string) {
    this.toastCtrl
      .create({
        message: text,
        duration: 1500,
        position: "bottom",
      })
      .present();
  }

  public confirm(
    text,
    title = "请确认",
    yes = "是",
    no = "否",
    enableBackdropDismiss = false
  ) {
    return new Promise((resolve, reject) => {
      this.alertCtrl
        .create({
          title: title,
          message: text,
          enableBackdropDismiss,
          buttons: [
            {
              text: no,
              role: "cancel",
              handler: () => {
                resolve(false);
              },
            },
            {
              text: yes,
              handler: () => {
                resolve(true);
              },
            },
          ],
        })
        .present();
    });
  }

  public getCarouselImages(image_url, carousel_images) {
    let img = [];
    img.push({ text: "", url: image_url });
    if (!carousel_images) return img;
    carousel_images = JSON.parse(carousel_images);
    carousel_images.forEach((_) => {
      img.push({ text: "", url: _ });
    });
    return img;
  }

  public isAndroidOrIOS() {
    let userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    return /android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream)
  }

  public isWeixin() {
    if (localStorage["mockWeixinEnv"]) {
      return true;
    }
    try {
      return (
        navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1 ||
        typeof window["navgator"].wxuserAgent !== "undefined"
      );
    } catch (e) {
      return false;
    }
  }
}

export function IsDebuggingMode() {
  return localStorage["flag-debugging"] === "true";
}

export function AlertIfDebugging(text) {
  if (IsDebuggingMode()) {
    alert(text);
  }
}

AlertIfDebugging("debugging enabled");



// WEBPACK FOOTER //
// ./src/services/util.ts